import React from 'react';
import ProgressHolderContainer from './progress-holder.styles';

const ProgressHolder = ({ name, progress }) => {
    return (
        <ProgressHolderContainer>
            <div className="prog-holder">
                <h4>{name}</h4>
                <div className="prog">
                    <span
                        style={{ width: `${progress}%` }}
                        data-progress={`${progress}%`}
                    ></span>
                </div>
            </div>
        </ProgressHolderContainer>
    );
};
export default ProgressHolder;
